/* Wet Water — transparent-over-hero header that solidifies on scroll.

   Only acts on pages that have a dark hero at the very top (homepage,
   collection PLPs + the About page), detected via the .wwg-overlay body class
   (added in theme.liquid). The transparent look + solid look are pure CSS (see
   wwg-custom.css); this script only:
     (a) keeps the fixed header glued just under the announcement bar as that
         bar scrolls away (sets the --wwg-top custom property),
     (b) publishes the header height as --wwg-header-h so the About sub-nav can
         stick just *below* the fixed bar instead of colliding with it, and
     (c) toggles the .wwg-solid class once you start scrolling.
   Dawn's own sticky-header animation is neutralised in CSS with !important, so
   the two never fight. Desktop only (min-width 990px) — mobile keeps the normal
   header; the script still runs but the CSS no-ops below 990px. */
(function () {
  function init() {
    var body = document.body;
    if (!body.classList.contains('wwg-overlay')) {
      return;
    }
    var wrap = document.querySelector('.header-wrapper');
    if (!wrap) return;

    var headerSection = wrap.closest('.shopify-section');
    var annSection = headerSection ? headerSection.previousElementSibling : null;

    var ticking = false;

    function apply() {
      ticking = false;

      // Glue the fixed header just below the (shrinking) announcement bar.
      var annBottom = 0;
      if (annSection) {
        var ar = annSection.getBoundingClientRect();
        annBottom = Math.max(0, ar.bottom);
      }
      wrap.style.setProperty('--wwg-top', annBottom + 'px');

      // Solid as soon as you scroll down at all (transparent only at the top).
      wrap.classList.toggle('wwg-solid', window.scrollY > 30);
    }

    function measure() {
      // Expose the header height on :root so the About sub-nav (which is not a
      // descendant of the header) can offset itself below the fixed bar.
      document.documentElement.style.setProperty('--wwg-header-h', wrap.offsetHeight + 'px');
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(apply);
      }
    }

    apply();
    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { onScroll(); measure(); });
    window.addEventListener('load', function () { apply(); measure(); });
    // Re-check after late layout shifts (web fonts, lazy hero image, etc.)
    setTimeout(function () { apply(); measure(); }, 350);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
